import { render, staticRenderFns } from "./DeliveryQuotationTransportTypes.vue?vue&type=template&id=2bb51131&scoped=true&"
import script from "./DeliveryQuotationTransportTypes.vue?vue&type=script&lang=js&"
export * from "./DeliveryQuotationTransportTypes.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryQuotationTransportTypes.vue?vue&type=style&index=0&id=2bb51131&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb51131",
  null
  
)

export default component.exports